<div class="container">
    <div class="nav-buttons">
        <ng-template #buttonsTmp let-item>
            <div class="nav-button">
                <app-button
                    [buttonClass]="item.active ? 'big-purple-gradient' : 'big-raisin-black'"
                    [text]="item.text"
                    [icon]="item.icon"
                    [iconDirection]="'left'"
                    (buttonClick)="setFilerAndRedirect(item)"
                ></app-button>
            </div>
        </ng-template>
        <app-home-carousel
            [items]="buttons"
            [currentIndex]="buttonsPage"
            [template]="buttonsTmp"
            [isShowArrow]="isMobile ? false : (isTablet ? buttons.length > 4 : buttons.length > 6)"
            [itemsPerSlide]="isMobile ? 3.2 : (isTablet ? 4.1 : 7.5)"
            [buttonsDirection]="'space-between'"
            [itemsMargin]="isMobile ? 6 : 12"
        ></app-home-carousel>
    </div>
</div>
